.card {
  height: 20%;
  width: calc(100% - 40px);
  padding: 0 20px;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.select {
  border: var(--border-width-default) solid var(--color-brand-300);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2FnZW50L193b3JrLzE0L3Mvc2VudGluZWwtZnJvbnQvc3JjL3BhZ2VzL0Rhc2hib2FyZC9mcmFnbWVudHMvU2lkZWJhci9mcmFnbWVudHMvQ2FyZEZpbHRlciIsInNvdXJjZXMiOlsiQ2FyZEZpbHRlci5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUVBOzs7QUFHRjtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLmNhcmQge1xuICBoZWlnaHQ6IDIwJTtcbiAgd2lkdGg6IGNhbGMoMTAwJSAtIDQwcHgpO1xuICBwYWRkaW5nOiAwIDIwcHg7XG4gIGJvcmRlci1yYWRpdXM6IDhweDtcbiAgYmFja2dyb3VuZDogd2hpdGU7XG4gIGN1cnNvcjogcG9pbnRlcjtcblxuICBib3gtc2hhZG93OiAwIDFweCAzcHggcmdiYSgwLCAwLCAwLCAwLjA2KTtcbn1cblxuLnNlbGVjdCB7XG4gIGJvcmRlcjogdmFyKC0tYm9yZGVyLXdpZHRoLWRlZmF1bHQpIHNvbGlkIHZhcigtLWNvbG9yLWJyYW5kLTMwMCk7XG59Il19 */